import React, { Component, PropTypes } from 'react'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import config from 'config'
import Styles from './BondDemoRedirect.css'
import container from '../../helpers/container'

import imageSocialShare from '../../../static/images/fossil-fuel-bonds-social-share.png'

@CSSModules(Styles, {allowMultiple:true})
export default class BondRedirect extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      title: 'Fossil Fuel Bonds in 401(k)s',
      description: 'If there are fossil fuel bonds in your 401(k), ' +
                   'you\'re effectively lending your retirement savings ' +
                   'to companies so they can mine for coal and drill ' +
                   'for oil.',
      url: config.domain + config.routes.fossilFuelBondsIn401ks,
    }
  }
  //
  render() {
    this.context.router.push(config.routes.fossilFuelBondsIn401ks)
    const socialShareUrl =  config.domain+imageSocialShare.replace(/.*dist/,'/dist')
    return (
      <div styleName='main'>
        { container.helmet(this.state.title,
                           this.state.description,
                           this.state.url) }
        <Helmet meta={[
          {property: 'og:image', content: socialShareUrl},
          {property: 'twitter:image', content: socialShareUrl},
        ]}/>
        <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={ false }/>
      </div>
    )
  }
}
